//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Locations from "~/content/data/locations.json";
export default {
  props: {
    mobile: {
      type: Array,
      required: true,
    },
    country: {
      type: String,
      default: "United States",
    },
  },
  data() {
    return {
      active: null,
      active2: null,
      activeLabel: null,
      level: 0,
      location: null,
      locations: null,
    };
  },
  created() {
    this.location = {
      ...Locations.find((c) => c.name.toLowerCase() === this.country.toLowerCase()),
    };
    // remove current location
    this.locations = Locations.filter(
      (c) => c.name.toLowerCase() !== this.country.toLowerCase()
    );
  },
  methods: {
    groupedLinks(menu) {
      const groupBy = function (objectArray, property) {
        return objectArray.reduce(function (acc, obj) {
          const key = obj[property];
          if (!acc[key]) {
            acc[key] = [];
          }
          acc[key].push(obj);
          return acc;
        }, {});
      };

      if (menu.tabs.length === 1) return groupBy(menu.tabs[0].links, "group");

      return groupBy(menu.tabs, "group");
    },
    _setActive2(t) {
      this.active2 = t === this.active ? null : t;
    },
    _setActiveMenu(index, label, level) {
      const self = this;
      this.active = index !== this.active ? index : null;
      this.activeLabel = label;

      this.$nextTick(function () {
        const menu = self.$refs.menu[index];
        if (menu) {
          menu.scrollIntoView();
        }
      });
    },
  },
};
